import { VideoPayload } from '@data';

import { queryClient } from '../config/client';
import { getSwingVideosKey } from '../hooks/useSwingVideos';

export const updateSwingVideos = (uuid: string, videos: VideoPayload[]) => {
    queryClient.setQueryData<VideoPayload[]>(getSwingVideosKey(uuid), videos);
};
